import { render, staticRenderFns } from "./SamLink.vue?vue&type=template&id=5620bff4&scoped=true&"
import script from "./SamLink.vue?vue&type=script&lang=js&"
export * from "./SamLink.vue?vue&type=script&lang=js&"
import style0 from "./SamLink.vue?vue&type=style&index=0&id=5620bff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620bff4",
  null
  
)

export default component.exports